export default {
    initialSetup: 'initialSetup',
    creatingSpace: 'creatingSpace',
    settingSpace: 'settingSpace',
    loadingSpaces: 'loadingSpaces'
}